const diaCompleto = [
  {
    text: '06:00',
    value: '06:00:00',
  },
  {
    text: '07:00',
    value: '07:00:00',
  },
  {
    text: '08:00',
    value: '08:00:00',
  },
  {
    text: '09:00',
    value: '09:00:00',
  },
  {
    text: '10:00',
    value: '10:00:00',
  },
  {
    text: '11:00',
    value: '11:00:00',
  },
  {
    text: '12:00',
    value: '12:00:00',
  },
  {
    text: '13:00',
    value: '13:00:00',
  },
  {
    text: '14:00',
    value: '14:00:00',
  },
  {
    text: '15:00',
    value: '15:00:00',
  },
  {
    text: '16:00',
    value: '16:00:00',
  },
  {
    text: '17:00',
    value: '17:00:00',
  },
  {
    text: '18:00',
    value: '18:00:00',
  },
  {
    text: '19:00',
    value: '19:00:00',
  },
  {
    text: '20:00',
    value: '20:00:00',
  },
  {
    text: '21:00',
    value: '21:00:00',
  },
];
const diaLite = [
  {
    text: '10:00',
    value: '10:00:00',
  },
  {
    text: '11:00',
    value: '11:00:00',
  },
  {
    text: '13:00',
    value: '13:00:00',
  },
  {
    text: '14:00',
    value: '14:00:00',
  },
  {
    text: '15:00',
    value: '15:00:00',
  },
  {
    text: '16:00',
    value: '16:00:00',
  },
  {
    text: '20:00',
    value: '20:00:00',
  },
  {
    text: '21:00',
    value: '21:00:00',
  },
];
//0 - Academia Premium
//1 - FitHit
//2 - Fight Kids
//3 - Pilates
//4 - Lets Run
//5 - Uma Nova Mulher
//6 - Academia Lite
//7 - Academia Flex

const produtoHorarios = {
  0: {
    1: diaCompleto,
    2: diaCompleto,
    3: diaCompleto,
    4: diaCompleto,
    5: diaCompleto,
    6: diaCompleto,
  },
  1: {
    2: [
      {
        text: '19:00',
        value: '19:00:00',
      },
    ],

    4: [
      {
        text: '19:00',
        value: '19:00:00',
      },
    ],
  },
  2: {
    1: diaCompleto,
    2: diaCompleto,
    3: diaCompleto,
    4: diaCompleto,
    5: diaCompleto,
    6: diaCompleto,
  },
  3: {
    2: [
      {
        text: '10:00',
        value: '10:00:00',
      },
    ],

    4: [
      {
        text: '10:00',
        value: '10:00:00',
      },
    ],
  },
  4: {
    1: diaLite,
    2: diaLite,
    3: diaLite,
    4: diaLite,
    5: diaLite,
    6: diaLite,
  },
  5: {
    1: diaCompleto,
    2: diaCompleto,
    3: diaCompleto,
    4: diaCompleto,
    5: diaCompleto,
    6: diaCompleto,
  },
  6: {
    1: diaLite,
    2: diaLite,
    3: diaLite,
    4: diaLite,
    5: diaLite,
    6: diaLite,
  },
  7: {
    1: diaCompleto,
    2: diaCompleto,
    3: diaCompleto,
    4: diaCompleto,
    5: diaCompleto,
    6: diaCompleto,
  },
  11: {
    1: diaCompleto,
    2: diaCompleto,
    3: diaCompleto,
    4: diaCompleto,
    5: diaCompleto,
    6: diaCompleto,
  },
  12: {
    1: diaCompleto,
    2: diaCompleto,
    3: diaCompleto,
    4: diaCompleto,
    5: diaCompleto,
    6: diaCompleto,
  },
};

export default { produtoHorarios, diaCompleto, diaLite };
